import React from 'react'
import styled from 'styled-components'

import { ReceiptMainContentHeader } from './components/ReceiptMainContentHeader'
import { ReceiptMainContentTable } from './components/ReceiptMainContentTable'

export const ReceiptMainContent = fragment => {
  const planNameText = fragment.roomName
    ? `${fragment.roomName} - ${fragment.planName}`
    : fragment.planName
  const spaceNameText = fragment.roomName
    ? `${fragment.roomName} / ${fragment.spaceName}`
    : fragment.spaceName

  return (
    <div>
      <StyledBillingTitle>{fragment.title}</StyledBillingTitle>
      <StyledBillingMainContentHeaderWrapper>
        <ReceiptMainContentHeader {...fragment} />
      </StyledBillingMainContentHeaderWrapper>
      <StyledBillingTableWrapper>
        <div>
          <StyledDetailSubHeader>
            <StyledDetailSubHeaderId>{`明細 # ${
              fragment.receiptDetailNumber
            }`}</StyledDetailSubHeaderId>
            <StyledDetailSubHeaderName>
              <dl>
                <StyledDetailSubHeaderPlanName>
                  {planNameText}
                </StyledDetailSubHeaderPlanName>
                <StyledDetailSubHeaderSpaceName>
                  {spaceNameText}
                </StyledDetailSubHeaderSpaceName>
              </dl>
            </StyledDetailSubHeaderName>
          </StyledDetailSubHeader>
          <ReceiptMainContentTable {...fragment} />
        </div>
      </StyledBillingTableWrapper>
    </div>
  )
}

const StyledBillingTitle = styled.h1`
  text-align: center;
  font-size: 24px;
  padding: 32px 0;
`
const StyledBillingMainContentHeaderWrapper = styled.div`
  margin-top: 40px;
`
const StyledBillingTableWrapper = styled.div`
  margin-top: 40px;
`

const StyledDetailSubHeader = styled.div`
  padding-bottom: 20px;
  border-bottom: 3px solid #222;
`
const StyledDetailSubHeaderId = styled.p`
  font-size: 14px;
`
const StyledDetailSubHeaderName = styled.div`
  margin-top: 12px;
`
const StyledDetailSubHeaderPlanName = styled.dt`
  font-size: 24px;
`
const StyledDetailSubHeaderSpaceName = styled.dd`
  margin: 6px 0 0;
  font-size: 18px;
`
